export const selectActiveMenu = (state) => state.menu.menuActive
